<div class="file-upload">
  <label class="upload-button">
    <i class="fas fa-upload"></i> Dateien hochladen
    <input type="file" accept="application/pdf" (change)="onFilesSelected($event)" multiple hidden />
  </label>

  <div class="file-list" *ngIf="uploadedFiles.length > 0">
    <ul>
      <li *ngFor="let file of uploadedFiles">
        <span>{{ file.name }}</span>
        <button (click)="removeFile(file)" class="delete-button">
          <i class="fas fa-times"></i>
        </button>
      </li>
    </ul>
  </div>
</div>